import * as React from 'react';
import cx from 'classnames';
import CloseOrb from '@clearkit/icons/glyphs/CloseOrb';

interface CKChipProps {
  icon?: JSX.Element;
  className?: string;
  onClick: () => void;
  children?: React.ReactNode;
}

export const CKChip = React.forwardRef(
  (props: CKChipProps, ref: React.Ref<HTMLSpanElement>) => {
    const { className, children, icon, onClick } = props;
    const chipClass = cx('ck-chip', className);
    return (
      <span ref={ref} className={chipClass}>
        {icon &&
          React.cloneElement(icon, {
            width: 16,
            height: 16,
            className: 'ck-chip-icon',
          })}
        {children}
        <button className="ck-chip-delete" onClick={onClick}>
          <CloseOrb width={16} height={16} />
        </button>
      </span>
    );
  }
);
